module.exports = __webpack_public_path__ + "components/app-promo/static/app-store_badge--black-2b877a4ed6c761dab8632d8d93814468.svg";